import { marked } from "marked";

/**
 * Escape for use inside HTML double-quoted attributes.
 */
export function escapeHtmlAttr(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;");
}

/**
 * Markdown renderer for Help / learning articles: Mermaid code fences + video from ![alt](url.mp4).
 * Keep in sync with m45-admin LearningArticlePreview (imports this module).
 */
export function createLearningArticleRenderer() {
  const renderer = new marked.Renderer();

  renderer.image = (hrefOrToken, title, text) => {
    let href;
    let titleVal;
    let textVal;
    if (hrefOrToken && typeof hrefOrToken === "object" && "href" in hrefOrToken) {
      href = hrefOrToken.href;
      titleVal = hrefOrToken.title;
      textVal = hrefOrToken.text;
    } else {
      href = hrefOrToken;
      titleVal = title;
      textVal = text;
    }
    const h = href || "";
    if (/\.(mp4|webm|mov)(\?|#|$)/i.test(h)) {
      const src = escapeHtmlAttr(h);
      const titleAttr = titleVal != null ? ` title="${escapeHtmlAttr(titleVal)}"` : "";
      return `<video class="learn-article-video" controls preload="metadata" playsinline src="${src}"${titleAttr}></video>`;
    }
    const escHref = escapeHtmlAttr(h);
    const escText = escapeHtmlAttr(textVal || "");
    const escTitle = titleVal != null ? ` title="${escapeHtmlAttr(titleVal)}"` : "";
    return `<img src="${escHref}" alt="${escText}"${escTitle} />`;
  };

  const defaultCodeRenderer = renderer.code.bind(renderer);
  renderer.code = (code, infostring, escaped) => {
    const isToken = typeof code === "object" && code !== null;
    const text = isToken ? code.text || "" : code || "";
    const lang = isToken ? code.lang || code.language || "" : infostring || "";

    if ((lang || "").trim().toLowerCase() === "mermaid") {
      return `<div class="mermaid">${text}</div>`;
    }

    if (isToken) {
      return defaultCodeRenderer(code);
    }
    return defaultCodeRenderer(text, infostring, escaped);
  };

  return renderer;
}

export function parseLearningArticleMarkdown(markdown) {
  if (!markdown) return "";
  return marked.parse(markdown, { breaks: true, renderer: createLearningArticleRenderer() });
}
